import { Link } from 'react-router-dom';
import styles from '../styles/AboutPage.module.css';

export default function AboutPage() {
  return (
    <main>

      {/* ── HERO BIO ─────────────────────────── */}
      <section className={styles['about-hero']}>
        <div className='container'>
          <div className={styles['about-hero__inner']}>

            {/* Photographer portrait */}
            <div className={styles['about-hero__image']}>
              {/* ← swap in your headshot or a candid field photo */}
              <img
                src='/Pictures/IMG_8760.jpeg'
                alt='Photographer in the field'
                loading='eager'
              />
            </div>

            {/* Bio copy */}
            <div>
              <p className={`label ${styles['about-hero__label']}`}>The photographer</p>
              <h1 className={styles['about-hero__title']}>
                {/* ← swap your name */}
                Mike Tsai
              </h1>
              <div className={styles['about-hero__bio']}>
                {/* ← swap in your own bio paragraphs */}
                <p>
                  What started as documenting every puppy moment I could catch 
                  slowly turned into a years-long visual diary. Somewhere along
                  the way, I started noticing how light would catch his fur - 
                  and then how it would move across everything else; the morning fog,
                  a friend's profile, the glow of golden hour. Photography
                  became less about the camera and more about learning to see.
                </p>
                <p>
                  I am currently pursuing a PhD, and this work is the counterbalance -
                  a reminder that not everything worth capturing fits in a dataset. 
                  What began as documenting my dog's growth turned into portrait 
                  sessions for friends, then family trips, then this portfolio I care
                  about enough to share with you all. The through-line is the same:
                  showing up for the moments that matter.

                </p>
                <p>
                  I'm currently in the Bay Area, balancing research with photoshoots 
                  and weekend adventures. If you are interested in my work - whether commissioning a shoot 
                  or ordering a print - reach out. 
                </p>
              </div>

              <div style={{ marginTop: '2rem', display: 'flex', gap: '1rem', flexWrap: 'wrap' }}>
                <Link to='/contact' className='btn'>Work with me</Link>
                <Link to='/portraits' className='btn--text' style={{ alignSelf: 'center' }}>
                  View portfolio →
                </Link>
              </div>
            </div>

          </div>
        </div>
      </section>

      {/* ── SPECIALISMS ──────────────────────── */}
      <section className={`section section--alt ${styles.specialisms}`}>
        <div className='container'>
          <div className='section-header'>
            <h2 className='heading-xl'>What I Do</h2>
          </div>

          <div className={styles['specialisms__grid']}>

            <div className={styles['specialism-card']}>
              <p className={styles['specialism-card__number']}>01</p>
              <h3 className={styles['specialism-card__title']}>Portraits</h3>
              <p className={styles['specialism-card__desc']}>
                Candid, warm, unhurried. Natural light so your personality comes through.
              </p>
            </div>

            <div className={styles['specialism-card']}>
              <p className={styles['specialism-card__number']}>02</p>
              <h3 className={styles['specialism-card__title']}>Events</h3>
              <p className={styles['specialism-card__desc']}>
                The room, the people, the moment between moments. Gatherings worth remembering.
              </p>
            </div>

            <div className={styles['specialism-card']}>
              <p className={styles['specialism-card__number']}>03</p>
              <h3 className={styles['specialism-card__title']}>Nature</h3>
              <p className={styles['specialism-card__desc']}>
                The outdoors in all its forms — sweeping, still, and occasionally staring back at you.
              </p>
            </div>

          </div>
        </div>
      </section>

    </main>
  );
}
